import { NgModule } from '@angular/core'
import { DisplayAddressPipe } from './display-address.pipe'

@NgModule({
    declarations: [DisplayAddressPipe],
    exports: [DisplayAddressPipe]
})
export class DisplayAddressModule {}